(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artifex-newsletter-popup"]) return;
  try {
    
  (function () {
    'use strict';
    var controllers = new WeakMap();
    var selector = '[data-artifex-newsletter]';

    function findPopups(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll(selector));
      if (root.nodeType === 1 && root.matches(selector)) items.unshift(root);
      return items;
    }

    function initPopup(root) {
      if (controllers.has(root)) return;
      var panel = root.querySelector('[data-newsletter-panel]');
      var email = root.querySelector('[data-newsletter-email]');
      var closeButton = panel.querySelector('[data-newsletter-close]');
      var form = root.querySelector('form');
      var result = root.querySelector('[data-newsletter-result]');
      var storageKey = 'artifex-newsletter-v1';
      var timer = 0;
      var hideTimer = 0;
      var previousFocus = null;
      var isOpen = false;
      var disarmed = false;
      var pendingWhenVisible = false;
      var designMode = Boolean(window.Shopify && window.Shopify.designMode);

      function read(key) {
        try { return window.localStorage.getItem(storageKey + ':' + key); } catch (_) { return null; }
      }

      function write(key, value) {
        try { window.localStorage.setItem(storageKey + ':' + key, String(value)); } catch (_) {}
      }

      function readSession(key) {
        try { return window.sessionStorage.getItem(storageKey + ':' + key); } catch (_) { return null; }
      }

      function writeSession(key, value) {
        try { window.sessionStorage.setItem(storageKey + ':' + key, String(value)); } catch (_) {}
      }

      function clearTimer() {
        window.clearTimeout(timer);
        timer = 0;
      }

      function focusableItems() {
        return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
      }

      function openPopup() {
        if (isOpen || disarmed) return;
        if (document.visibilityState === 'hidden') {
          pendingWhenVisible = true;
          clearTimer();
          return;
        }
        clearTimer();
        pendingWhenVisible = false;
        window.clearTimeout(hideTimer);
        previousFocus = document.activeElement;
        root.hidden = false;
        root.offsetHeight;
        root.classList.add('is-visible');
        document.documentElement.classList.add('artifex-newsletter-open');
        document.body.classList.add('artifex-newsletter-open');
        isOpen = true;
        panel.scrollTop = 0;
        window.setTimeout(function () {
          var needsScrolling = panel.scrollHeight > panel.clientHeight + 1;
          var focusTarget = needsScrolling ? (closeButton || panel) : (email || closeButton || panel);
          try { focusTarget.focus({ preventScroll: true }); } catch (_) { focusTarget.focus(); }
          panel.scrollTop = 0;
        }, 40);
      }

      function closePopup(remember) {
        if (!isOpen) return;
        root.classList.remove('is-visible');
        document.documentElement.classList.remove('artifex-newsletter-open');
        document.body.classList.remove('artifex-newsletter-open');
        isOpen = false;
        if (remember && !designMode) {
          writeSession('dismissed', '1');
          disarmed = true;
          clearTimer();
        }
        hideTimer = window.setTimeout(function () { if (!isOpen) root.hidden = true; }, 240);
        if (previousFocus && previousFocus.focus && document.contains(previousFocus)) previousFocus.focus();
      }

      function onKeydown(event) {
        if (!isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup(true);
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusableItems();
        if (!items.length) {
          event.preventDefault();
          panel.focus();
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function onRootClick(event) {
        if (event.target.closest('[data-newsletter-close]')) closePopup(true);
      }

      function onFormSubmit() {
        var submit = form.querySelector('[data-newsletter-submit]');
        if (submit) submit.disabled = true;
      }

      function onVisibilityChange() {
        if (document.visibilityState === 'visible' && pendingWhenVisible && !isOpen) openPopup();
      }

      function schedule() {
        if (designMode || disarmed) return;
        if (read('subscribed') === '1') return;
        if (readSession('dismissed') === '1') return;
        var delay = Math.max(0, Number(root.getAttribute('data-delay-seconds')) || 0) * 1000;
        timer = window.setTimeout(openPopup, delay);
      }

      root.addEventListener('click', onRootClick);
      root.addEventListener('keydown', onKeydown);
      if (form) form.addEventListener('submit', onFormSubmit);
      document.addEventListener('visibilitychange', onVisibilityChange);

      controllers.set(root, {
        open: openPopup,
        close: function () { closePopup(false); },
        destroy: function () {
          disarmed = true;
          clearTimer();
          window.clearTimeout(hideTimer);
          document.removeEventListener('visibilitychange', onVisibilityChange);
          root.removeEventListener('click', onRootClick);
          root.removeEventListener('keydown', onKeydown);
          if (form) form.removeEventListener('submit', onFormSubmit);
          document.documentElement.classList.remove('artifex-newsletter-open');
          document.body.classList.remove('artifex-newsletter-open');
        }
      });

      if (result && result.getAttribute('data-newsletter-result') === 'success') {
        write('subscribed', '1');
        openPopup();
      } else if (result && result.getAttribute('data-newsletter-result') === 'error') {
        openPopup();
      } else {
        schedule();
      }
    }

    function init(root) {
      findPopups(root).forEach(initPopup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);

    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      findPopups(event.target).forEach(function (popup) {
        var controller = controllers.get(popup);
        if (controller) controller.destroy();
        controllers.delete(popup);
      });
    });
    document.addEventListener('shopify:section:select', function (event) {
      var popup = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      var controller = popup && controllers.get(popup);
      if (controller) controller.open();
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      var popup = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      var controller = popup && controllers.get(popup);
      if (controller) controller.close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
